export default {
  install(Vue, store) {
    Vue.prototype.$alert = function (title, type, extraConfig = {}) {
      return this.$root.$emit("alert", { title, type, ...extraConfig });
    };

    Object.defineProperty(Vue.prototype, "$settings", {
      get() {
        return store.state.settings;
      },
    });

    Object.defineProperty(Vue.prototype, "$features", {
      get() {
        return store.getters.features;
      },
    });
  },
};
